export const statuses = [
    {
        'value': 'active',
        'label': 'Active',
        'default': true
    },
    {
        'value': 'inactive',
        'label': 'Inactive',
        'default': false
    },
    {
        'value': 'sold',
        'label': 'Sold',
        'default': false
    },
    {
        'value': 'stolen',
        'label': 'Stolen',
        'default': true
    },
    {
        'value': 'claims',
        'label': 'Claims',
        'default': true
    },
    {
        'value': 'hold_for_sale',
        'label': 'Hold for Sale',
        'default': true
    },
    {
        'value': 'sold_not_delivered',
        'label': 'Sold Not Delivered',
        'default': true
    },
    {
        'value': 'in_maintenance',
        'label': 'In Maintenance',
        'default': true
    },
    {
        'value': 'at_auction',
        'label': 'At Auction',
        'default': true
    },
    {
        'value': 'hold',
        'label': 'Hold',
        'default': true
    }
];

export const defaultStatuses = statuses.filter(status => status.default);

export const defaultStatusValues = defaultStatuses.map(status => status.value);

export const getStatusByValue = (value) => {
    const status = statuses.find(status => status.value === value);
    if (!status) {
        return null;
    }

    return status;
}

export const getLabelByValue = (value) => {
    const status = statuses.find(status => status.value === value);
    if (!status) {
        return null;
    }

    return status.label;
}

export const priceAlertPeriodTypes = [
    {
        'value': 'one_day_change',
        'label': 'One day',
    },
    {
        'value': 'two_days_change',
        'label': 'Two days',
    },
    {
        'value': 'seven_days_change',
        'label': 'Seven days',
    },
    {
        'value': 'one_month_change',
        'label': 'One month',
    },
    {
        'value': 'three_months_change',
        'label': 'Three months',
    },
    {
        'value': 'six_months_change',
        'label': 'Six months',
    },
    {
        'value': 'one_year_change',
        'label': 'One year',
    },
]

export const getPriceAlertPeriodTypeByValue = (value) => {
    const type = priceAlertPeriodTypes.find(type => type.value === value);
    if (!type) {
        return null;
    }

    return type;
}

export const getPriceAlertPeriodLabelByValue = (value) => {
    const type = priceAlertPeriodTypes.find(type => type.value === value);
    if (!type) {
        return null;
    }

    return type.label;
}

export const priceAlertChangeTypes = [
    {
        'value': 'increase',
        'label': 'Increase price alert',
    }, {
        'value': 'decrease',
        'label': 'Decrease price alert',
    },
]

export const getPriceAlertChangeTypeByValue = (value) => {
    const type = priceAlertChangeTypes.find(type => type.value === value);
    if (!type) {
        return null;
    }

    return type;
}

export const getPriceAlertChangeLabelByValue = (value) => {
    const type = priceAlertChangeTypes.find(type => type.value === value);
    if (!type) {
        return null;
    }

    return type.label;
}

export const conditions = [
    {
        label: "Above",
        value: "excellent",
    },
    {
        label: "Average",
        value: "good",
    },
    {
        label: "Below",
        value: "fair",
    },
];

export const getConditionByValue = (value) => {
    const condition = conditions.find(condition => condition.value === value);
    if (!condition) {
        return null;
    }

    return condition;
}

export const getConditionLabelByValue = (value) => {
    const condition = conditions.find(condition => condition.value === value);
    if (!condition) {
        return null;
    }

    return condition.label;
}

export const subscriptionStatuses = [
    {
        label: "Active",
        value: "active",
        color: "green",
    },
    {
        label: "Canceled",
        value: "canceled",
        color: "red",
    },
    {
        label: "Cancel Scheduled",
        value: "cancel_scheduled",
        color: "orange",
    },
    {
        label: "Expired",
        value: "expired",
        color: "warning",
    },
    {
        label: "Failed",
        value: "failed",
        color: "red",
    },
    {
        label: "Pending",
        value: "pending",
        color: "blue",
    },
];

export const subscriptionStatusByValue = value => {
    const status = subscriptionStatuses.find(status => status.value === value);
    if (!status) {
        return null;
    }

    return status;
}

export const subscriptionStatusLabelByValue = value => {
    const condition = subscriptionStatusByValue(value);
    if (!condition) {
        return null;
    }

    return condition.label;
}

export const sellProviders = [
    {
        'value': 'fmh',
        'label': 'Fleet Market Hub',
        'default': false
    },
    {
        'value': 'advent_resource',
        'label': 'Advent Resource',
        'default': false
    }
];

export const defaultSellProviders = sellProviders.filter(provider => provider.default);

export const defaultSellProviderValues = defaultStatuses.map(provider => provider.value);

export const getSellProviderByValue = (value) => {
    const provider = sellProviders.find(provider => provider.value === value);
    if (!provider) {
        return null;
    }

    return provider;
}

export const getSellProvider = (value) => {
    const provider = sellProviders.find(provider => provider.value === value);
    if (!provider) {
        return null;
    }

    return provider.label;
}
